export function getFormattedName(userData) {
  if (userData && userData.name) {
    if (userData.name.length > 12) {
      return userData.name.slice(0, 12).concat('...');
    }
    return userData.name;
  }
  return '';
}
